import { commentsData } from '@/mocks/home';

function renderStars(n: number) {
  return Array.from({ length: 5 }, (_, i) => (
    <i
      key={i}
      className={`text-xs ${i < n ? 'ri-star-fill text-accent-500' : 'ri-star-fill text-background-300'}`}
    ></i>
  ));
}

export default function CommentsSection() {
  return (
    <section id="comments" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            观众评价
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-[500px] mx-auto">
            听听用户们怎么说
          </p>
        </div>
        <div className="max-w-[900px] mx-auto grid grid-cols-1 md:grid-cols-3 gap-5">
          {commentsData.map((item, i) => (
            <div
              key={i}
              className="p-6 rounded-xl bg-background-50 border border-background-200/70"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                  <img
                    src={item.avatar}
                    alt={item.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="text-sm font-medium text-foreground-800 truncate">
                    {item.name}
                  </div>
                  <div className="text-xs text-foreground-400">{item.time}</div>
                </div>
              </div>
              <div className="flex items-center gap-1 mb-3">
                {renderStars(item.rating)}
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {item.content}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}